// extracted by mini-css-extract-plugin
var _1 = "IdwellToIdwellRequestFormModal-moduledisabledPointerEvents__CJ5wF";
export { _1 as "disabledPointerEvents" }
